import axios from 'axios'

// eslint-disable-next-line import/prefer-default-export
export const getMaintInfo = async ({ chatId, week }) => {
  const res = await axios.post('/api/getMaintInfo', { chatId, week })
  return res.data
}
